import React from 'react';
import { SocialSharePlatformProvider } from '../SocialSharePlatformContext';
import { SocialSharePlatformProviderProps } from '../types';
import useFacebookSocialShare from './useFacebookSocialShare';

const FacebookSocialShareProvider: React.FC<SocialSharePlatformProviderProps> = ({
  children,
}) => {
  const platformData = useFacebookSocialShare();

  return (
    <SocialSharePlatformProvider value={platformData}>
      {children}
    </SocialSharePlatformProvider>
  );
};

export default FacebookSocialShareProvider;
